import {createContext, Dispatch, ReactNode, SetStateAction, useState} from 'react';

import Popup from '@/shared/components/Popup';

export type PopupState<T extends string> = {
  isOpen: boolean;
  type?: T;
  props?: any;
};

export type PopupSetter<T extends string> = Dispatch<SetStateAction<PopupState<T>>>;

export const PopupStateContext = createContext<PopupState<string>>({isOpen: false});
export const PopupSetterContext = createContext<PopupSetter<string> | Function>(() => {});

export type PopupProviderProps<T extends string> = {
  components: Record<T, (props: any) => JSX.Element>;
  children: ReactNode;
};

const Empty = () => null;

const PopupProvider = <T extends string>({components, children}: PopupProviderProps<T>) => {
  const [state, setState] = useState<PopupState<T>>({isOpen: false});
  const closePopup = () => setState({isOpen: false});
  const ComponentOnPopup = state.type ? components[state.type] : Empty;

  return (
    <PopupSetterContext.Provider value={setState}>
      <PopupStateContext.Provider value={state}>
        {children}
        <Popup {...state} closePopup={closePopup}>
          <ComponentOnPopup {...state.props} />
        </Popup>
      </PopupStateContext.Provider>
    </PopupSetterContext.Provider>
  );
};

export default PopupProvider;
